import { ScrollArea as BaseScrollArea } from '@base-ui/react/scroll-area';
import type { ComponentProps } from 'react';

import { cn } from '../lib/cn';

/**
 * "최상위 페이지는 뷰포트 높이를 넘지 않고, 콘텐츠는 각 영역 내부에서 스크롤한다"
 * — L2-06 §8 단일 화면 유지. 그 영역별 스크롤 컨테이너.
 */
export function ScrollArea({
  className,
  children,
  ...props
}: ComponentProps<typeof BaseScrollArea.Root>) {
  return (
    <BaseScrollArea.Root className={cn('relative overflow-hidden', className)} {...props}>
      <BaseScrollArea.Viewport className="h-full w-full overscroll-contain">
        <BaseScrollArea.Content>{children}</BaseScrollArea.Content>
      </BaseScrollArea.Viewport>

      <BaseScrollArea.Scrollbar
        orientation="vertical"
        className="duration-base flex w-2 touch-none justify-center p-0.5 opacity-0 transition-opacity data-[hovering]:opacity-100 data-[scrolling]:opacity-100"
      >
        <BaseScrollArea.Thumb className="rounded-pill bg-ink-faint/50 w-full" />
      </BaseScrollArea.Scrollbar>

      <BaseScrollArea.Corner />
    </BaseScrollArea.Root>
  );
}
